import type { QueryClient } from '@tanstack/react-query';
import { queryRoots } from '@/shared/query';

export function invalidateSlackStatus(client: QueryClient): Promise<void> {
  return client.invalidateQueries({
    predicate: (q) => {
      const key = q.queryKey;
      return (
        Array.isArray(key) &&
        key[0] === queryRoots.plugins &&
        key[1] === 'slack' &&
        key[2] === 'status'
      );
    },
  });
}
